import EntityBaseRepository from '@/api/EntityBaseRepository';
import { AxiosResponse } from 'axios';
import { Station } from "@/models/station";
import { Machine } from "@/models/machine";

export default class ChecklistRepository extends EntityBaseRepository {



    public getChecklist(machineId: string): Promise<any> {
        return this.axiosClient.get(`checklist/${machineId}`);
    }

    public getChecklists(stationId: string): Promise<any> {
        return this.axiosClient.get(`checklists/${stationId}`);
    }
}

